module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-up.832151a7.svg";